import { FaClock, FaUserCheck, FaUserTimes, FaQuestionCircle, FaPhoneSlash, FaPhone, FaBan,FaTimesCircle , FaMapMarkerAlt  , FaExchangeAlt, FaUsers } from 'react-icons/fa';

export const getEstadoIcon = (estadoId) => {
  switch (estadoId) {
    case 1: return <FaClock style={{ color: '#1890ff' }} />;
    case 2: return <FaUserCheck style={{ color: '#52c41a' }} />;
    case 3: return <FaUserTimes style={{ color: '#ff4d4f' }} />;
    default: return <FaQuestionCircle />;
  }
};

export const getSubestadoIcon = (subestadoId) => {
  switch (subestadoId) {
    case 1: return <FaPhoneSlash style={{ color: '#ffa940' }} />;
    case 2: return <FaPhone style={{ color: '#ffa940' }} />;
    case 3: return <FaBan style={{ color: '#ffa940' }} />;
    case 4: return <FaUserTimes style={{ color: '#ff4d4f' }} />;
    default: return <FaQuestionCircle />;
  }
};

export const getMotivoIcon = (motivoCodigo) => {
  switch (motivoCodigo) {
    case 'FUERA_TERRITORIO':
      return <FaMapMarkerAlt style={{ color: '#ff4d4f' }} />;
    case 'CAMBIO_RESIDENCIA':
      return <FaExchangeAlt style={{ color: '#ff4d4f' }} />;
    case 'DUPLICIDAD_TITULAR':
      return <FaUserTimes style={{ color: '#ff4d4f' }} />;
    case 'FALLECIMIENTO':
      return <FaTimesCircle    style={{ color: '#ff4d4f' }} />;
    case 'DESISTIMIENTO':
      return <FaBan style={{ color: '#ff4d4f' }} />;
    case 'NO_ACEPTA_PROGRAMA':
      return <FaBan style={{ color: '#ff4d4f' }} />;
    case 'OTRO_PROGRAMA_DIP':
      return <FaUsers style={{ color: '#ff4d4f' }} />;
    case 'INFO_NO_COMPROBABLE':
      return <FaQuestionCircle style={{ color: '#ff4d4f' }} />;
    case 'TRES_INTENTOS_SIN_RESPUESTA':
      return <FaQuestionCircle style={{ color: '#ff4d4f' }} />;
    case 'OTRO':
      return <FaQuestionCircle style={{ color: '#ff4d4f' }} />;
    default:
      return <FaQuestionCircle style={{ color: '#999' }} />;
  }
};